import { createContext } from 'react'
import { CatalogFilters, CatalogOrder, CatalogSubscriptionStatus } from '../../types'

export type CatalogFilterActionAddFilter = { filterId: string; value: string }

export type CatalogFilterContext = {
  state: {
    filtersClosedManually: string[]
    page: number
    filtersShown: boolean
    filters: CatalogFilters
    fullTextSearch?: string
    subscribedBy: CatalogSubscriptionStatus
    orderBy: CatalogOrder
  }
  actions: {
    setClosedManually: (filterId: string) => void
    clearCloseManually: () => void
    setFiltersShown: (open: boolean) => void
    setPage: (page: number) => void
    addFilterValue: (data: CatalogFilterActionAddFilter) => void
    setFilters: (filters: Partial<CatalogFilters>) => void
    clearFilters: () => void
    clearAll: () => void
    setOrderBy: (orderBy: CatalogOrder) => void
    setFullTextSearch: (searchText: string) => void
    setSubscribedBy: (subscribed: CatalogSubscriptionStatus) => void
  }
}

export enum CatalogFilterActions {
  setClosedManually = 'setClosedManually',
  clearCloseManually = 'clearCloseManually',
  setFiltersShown = 'setFiltersShown',
  setPage = 'setPage',
  addFiltersValue = 'addFiltersValue',
  setFilters = 'setFilters',
  clearFilters = 'clearFilters',
  clearAll = 'clearAll',
  setFullTextSearch = 'setFullTextSearch',
  setOrderBy = 'setOrderBy',
  setSubscribedBy = 'setSubscribedBy'
}

export type CatalogFilterAction = {
  type: CatalogFilterActions
  payload?:
    | CatalogFilterContext['state'][keyof CatalogFilterContext['state']]
    | Partial<CatalogFilters>
    | CatalogFilterActionAddFilter
}

const stub = (_payload: CatalogFilterAction['payload'][keyof CatalogFilterAction['payload']]): void => {
  throw new Error('You forgot to wrap your component in <FiltersProvider>.' + _payload)
}

export const FILTERS_INITIAL_DATA = {
  state: {
    page: 1,
    filtersShown: true,
    filtersClosedManually: [],
    filters: {
      countries: [],
      categories: [],
      licenses: [],
      providers: [],
      sources: [],
      useCases: [],
      temporalAggs: [],
      spatialAggs: []
    },
    subscribedBy: CatalogSubscriptionStatus.ALL,
    orderBy: CatalogOrder.RANK,
    fullTextSearch: ''
  },
  actions: {
    setClosedManually: stub,
    clearCloseManually: stub,
    setFiltersShown: stub,
    setPage: stub,
    addFilterValue: stub,
    setFilters: stub,
    clearFilters: stub,
    setOrderBy: stub,
    setFullTextSearch: stub,
    setSubscribedBy: stub
  }
} as unknown as CatalogFilterContext

export const FiltersContext = createContext(FILTERS_INITIAL_DATA.state)
export const FiltersActionsContext = createContext(FILTERS_INITIAL_DATA.actions)
